export default "__VITE_ASSET__5286459b__"